export default "__VITE_ASSET__ab813f95__"